import { Link } from "react-router-dom";
import { siteInfo, categories } from "@/mocks/archive";

export default function Footer() {
  return (
    <footer className="bg-accent-950 text-background-100">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <span className="w-10 h-10 flex items-center justify-center bg-background-50 text-accent-950 font-heading text-lg rounded-md">
                溯
              </span>
              <span className="font-heading text-xl font-bold text-background-50">
                {siteInfo.brand}
              </span>
            </div>
            <p className="text-sm leading-relaxed text-background-200">
              {siteInfo.slogan}。用档案的方式整理网络人物的公开言行，让每一次围观都有据可查。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              站点导航
            </h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/" className="text-background-200 hover:text-background-50 transition-colors">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/archive" className="text-background-200 hover:text-background-50 transition-colors">
                  考古档案
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-background-200 hover:text-background-50 transition-colors">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-background-200 hover:text-background-50 transition-colors">
                  联系我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              档案分类
            </h4>
            <ul className="space-y-2 text-sm">
              {categories.slice(0, 5).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to="/archive"
                    className="text-background-200 hover:text-background-50 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              联系与说明
            </h4>
            <ul className="space-y-3 text-sm text-background-200">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-base"></i>
                <a
                  href={`mailto:${siteInfo.email}`}
                  className="hover:text-background-50 transition-colors break-all"
                >
                  {siteInfo.email}
                </a>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-information-line text-base mt-0.5"></i>
                <span>仅整理公开信息，不涉及任何非公开个人隐私。</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-accent-800 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-300">
          <p>© 2019-2026 {siteInfo.brand} · 内容仅供公开信息整理与讨论</p>
          <p>档案会持续校验存档，历史链接失效会标注而不删除</p>
        </div>
      </div>
    </footer>
  );
}